import {SmallCard} from '../small-card.component';
import {
    AnimationIcon,
    ArtIcon,
    DocumentIcon,
    EndToEndIcon,
    GameDesignIcon,
    IdeaIcon,
    ProcessIcon,
    ReskinIcon,
    UIUXIcon
} from '../icons';
import {ReactNode} from 'react';
import {motion} from 'framer-motion';
import Divider from '../Divider';

const OurServices = [
    {
        title: 'Unique 2D Art',
        description: 'You get stunning 2D art that brings your game to life. We create vibrant, detailed, and captivating visuals that will engage and excite your players.',
        icon: <ArtIcon/>,
    },
    {
        title: 'Animation',
        description: 'Our animators are skilled in creating dynamic and fluid animations that enhance the player experience. We bring characters, symbols, and effects to life with smooth and engaging motion.',
        icon: <AnimationIcon/>,
    },
    {
        title: 'UI/UX Design',
        description: 'You get intuitive and visually appealing user interfaces that enhance the player experience. We create layouts, icons, and animations that are easy to use and navigate.',
        icon: <UIUXIcon/>,
    },
    {
        title: 'Game reskinning',
        description: 'Reskinning can give your existing game a fresh new look. We can redesign characters, backgrounds, and UI elements to create a unique and engaging experience.',
        icon: <ReskinIcon/>,
    },
    {
        title: 'End to end Art Production',
        description: 'We offer end-to-end art production services to bring your game from concept to completion. Our team can handle every aspect of art creation, from concept art to final assets.',
        icon: <EndToEndIcon/>,
    },
    {
        title: 'Art for marketing',
        description: 'We create eye-catching art for marketing materials to help promote your game. Our artists can design banners, ads, and social media graphics that attract and engage players.',
        icon: <GameDesignIcon/>,
    },
];

const OurProcess = [
    {
        title: 'Agree the contract',
        description: 'We agree on the terms of the contract and sign it. We provide a detailed timeline and budget for the project, so you know exactly what to expect.',
        icon: <DocumentIcon/>
    },
    {
        title: 'Concept and design',
        description: 'Our team works closely with you to develop a concept and design that aligns with your vision and goals. We create mood boards, sketches, and wireframes to bring your ideas to life.',
        icon: <IdeaIcon/>
    },
    {
        title: 'Art and animation production',
        description: 'Once the concept is approved, our artists and animators get to work creating the assets for your game. We use industry-standard tools and techniques to ensure high-quality results.',
        icon: <ProcessIcon/>
    },
    // {
    //     title: 'Integration and deployment',
    //     description: 'Once the art is complete, we help you integrate it into your platform and deploy it to your players. We provide ongoing support and updates to ensure a seamless player experience.',
    //     icon: <GameDesignIcon/>
    // },
]
const DescriptionSection: React.FC<{
    showService?: boolean,
    showProcess?: boolean,
    title?: string,
    children?: ReactNode
}> = ({children, showService, showProcess, title}) => {
    return (
        <motion.section
            initial={{opacity: 0, scale: 0.8}}
            whileInView={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
            viewport={{once: true}}
            className="w-screen  sm:min-h-screen p-10 relative">
            <img
                alt=""
                className={`absolute top-0 left-0 w-full transform ${showProcess ? '' : 'scale-x-[-1]'} object-cover opacity-15`}
                src="https://storage.googleapis.com/lesia-k/Pictures/Illustration1.png"
            />
            <Divider/>

            <motion.div
                initial={{opacity: 0, scale: 0.8}}
                whileInView={{opacity: 1, scale: 1}}
                transition={{duration: 0.5}}
                viewport={{once: true}}
                className="flex flex-col gap-8">
                <div className="flex justify-center items-center mt-10">
                    <h1 className="text-6xl font-bold text-center max-w-6xl font-boldonse text-transparent bg-clip-text bg-gradient-to-l from-pink-200 to-pink-400 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{title || 'Dynamic 2D art and animations for casino games'}</h1>
                </div>
                {showService && (<div className="flex flex-col gap-6 justify-center items-center">
                    <div className="flex flex-col gap-2">
                        {/*    cards of out services*/}
                        <div className="mt-10 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {OurServices.map((service, index) => (
                                <SmallCard feature={service} index={index}/>))}
                        </div>
                    </div>
                    {children && (children)}
                </div>)}
                {showProcess && (<div className="flex flex-col gap-6 justify-center items-center">
                    <div className="flex flex-col gap-2">
                        <h2 className="text-3xl font-bold text-center text-white">Our Process</h2>
                        {/*    cards of out services*/}
                        <div className="mt-10 max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {OurProcess.map((service, index) => (
                                <SmallCard feature={service as any} index={index}/>))}
                        </div>
                    </div>

                </div>)}

            </motion.div>
        </motion.section>
    );
}

export default DescriptionSection;
